import React from 'react';
import Navbar from '../../components/common/Header/Navbar';
import bannerimg from '../../assets/Recharge_api_images/kyc_banner.png';
import missionvissonimg from '../../assets/Recharge_api_images/kyc_api_img.jpg';
import "../../styles/recharge_api.css";
import increasedRevenueIcon from '../../assets/Recharge_api_images/increase1.png';
import scalabilityIcon from '../../assets/Recharge_api_images/relationships2.png';
import customerRetentionIcon from '../../assets/Recharge_api_images/retension.png';
import fintechIcon from '../../assets/Recharge_api_images/fintech.png';
import retailIcon from '../../assets/Recharge_api_images/retail.png';
import ecommerceIcon from '../../assets/Recharge_api_images/Ecommerce.png';
import benefitBanner from '../../assets/Recharge_api_images/benefit_banner.png';

import securityMeasuresImage from '../../assets/Recharge_api_images/security1.png';
import securitysecurityMeasuresImage from '../../assets/Recharge_api_images/security2.png';


import integrationProcessImage from '../../assets/Recharge_api_images/integration_background.png';

const KycApis = () => {

  const FeatureBox = ({ title, description, isPrimary = false , className = '' }) => (
    <div className={`feature-box ${isPrimary ? 'feature-box-primary' : 'feature-box-secondary'} ${className}`}>
      <h4 className="feature-title font-lato text-[20px] font-bold">{title}</h4>
      <p className="feature-description text-ellipsis  font-lato text-[17px] font-normal leading-[26px]">{description}</p>
    </div>
  );

  // ✅ you used values in CoreValues & HowItWorks but didn’t define it
  const values = [
    { title: "Integrity", desc: "We believe in transparency and trust." },
    { title: "Innovation", desc: "We build solutions for tomorrow." },
  ];

const BenefitCard = ({ icon, title, description, isBlue = false }) => (
  <div
    className={`benefit-card ${isBlue ? 'benefit-card-blue' : 'benefit-card-white'} group p-6 rounded-xl shadow-lg transition-colors duration-300 cursor-pointer`}
  >
    <div className="card-icon-container mb-4">
      {icon ? (
        <img src={icon} alt={title} className="card-icon w-12 h-12" />
      ) : (
        <div className="card-icon-placeholder w-12 h-12"></div>
      )}
    </div>
    <h3 className="card-title text-gray-900 text-xl font-semibold mb-2 transition-colors duration-300">
      {title}
    </h3>
          <p 
        className="card-description text-[#6E6E6E] transition-colors duration-300 font-lato text-[17px] font-normal leading-[26px]"
      >
        {description}
      </p>
  </div>
);



   const renderImageCard = (imageSrc, altText, title, description, linkText) => (
        <div className="image-card-container">
            {/* The main background image holder (dark curved shape) */}
            <div className="image-card-background">
                {imageSrc ? (
                    <img src={imageSrc} alt={altText} className="content-image" />
                ) : (
                    <div className="image-placeholder"></div>
                )}
            </div>
            
            {/* The nested white card with text overlay */}
            <div className="image-text-card">
                <h3>{title}</h3>
                <p>{description}</p>
                <a href="#" className="see-more-link">{linkText} →</a>
            </div>
        </div>
    );



  return (
    <>
      {/* Navbar */}
      {/* <Navbar /> */}

      {/* Banner Section */}

            <div className="relative w-full h-[300px] md:h-auto min-h-52">
                <img
                    src={bannerimg}
                    alt="About Banner"
                    className="w-full h-full object-cover" // Added h-full and object-cover to make sure the image fills the container height
                />
                <div className="banner-content absolute inset-0  flex flex-col items-center justify-center px-6 py-12 xs:pb-1 md:pb-1 ">
                    <h1 
                        className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal" // Made font size responsive
                    >
                            KYC API
                    </h1>

                    <p 
                        className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2" // Made font size responsive and added margin top
                    >
                           Comprehensive Identity Verification with PAN, CIN, DIN, Passport, and More 

                    </p>
                </div>
            </div>





      {/* Content Section */}

<section className="recharge-api-section">
  <div className="content-container">
    {/* --- LEFT COLUMN: TEXT & FEATURES --- */}
    <div className="text-and-features-column">
      <p className="section-tag">OUR CORE API SERVICES</p>
      <h1 className="main-title">
        Secure Identity Verification <br />with Aadhaar, Passport & <br />More 
      </h1>
      <p className="main-description font-lato text-[17px] font-normal leading-[26px]">
        Ensure secure identity verification with Aadhaar, passport, and other official documents,
        enabling fast and reliable KYC compliance for businesses.
      </p>

      {/* --- FEATURES GRID --- */}
      <div className="features-grid">
        {/* ROW 1 */}
        <FeatureBox
          title="Instant Verification"
          description="Authenticate instantly using government-approved databases for instant verification"
          className="feature-box-2-of-5"
        />
        <FeatureBox
          title="Multiple Verification Methods"
          description="Supports biometric, OTP-based, and document verification for secure authentication"
          className="feature-box-2-of-5"
        />

        {/* ROW 2 */}
        <FeatureBox
          title="Regulatory Compliance"
          description="Adheres to RBI, SEBI, and AML guidelines for secure and lawful operation"
          className="feature-box-3-of-5"
        />
        <FeatureBox
          title="AI-Powered Fraud Prevention"
          description="Enhances security with AI-driven identity checks to detect and preventation"
          className="feature-box-3-of-5"
        />
      </div>
      {/* --- END FEATURES GRID --- */}
    </div>

    {/* --- RIGHT COLUMN: IMAGE + LAST FEATURE BOX --- */}
<div className="illustration-column flex flex-col items-start gap-8 ml-24">
  <img
    src={missionvissonimg}
    alt="Identity Verification Illustration"
    className="recharge-illustration max-w-full h-auto"
  />
  <FeatureBox
    title="Reliable API Integration"
    description={
      <>
        Ensure seamless connectivity with minimal <br /> downtime for uninterrupted operations.
      </>
    }
    className="seamless-card-int feature-box-3-of-5 w-max"
  />
</div>

  </div>
</section>


  {/* Our Mission Section */}
  <div>
    <section className="benefits-section relative overflow-hidden">
      <div
        className="absolute top-0 left-0 w-full h-[400px]  z-0"
        style={{
          backgroundImage: `url(${benefitBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      {/* 3. Apply the style object and add an overlay div */}
      <div className="benefits-header-content-bg">
        {/* 4. Overlay div for the dark blue tint effect from the original image */}
        <div className="benefits-header-overlay"></div>
      </div>

      <div className="benefits-header-content">
        <div className="header-text-container">
          <p className="header-tag">BENEFITS & USE CASES</p>
          <h2 className="header-title">Maximize Efficiency with Our APIs</h2>
        </div>
        <div className="header-description-container">
          <p className="header-description text-justify">
            Enhance your business with secure, fast, and scalable API solutions. Streamline transactions, optimize operations, and improve customer experience effortlessly.
          </p>
        </div>
      </div>

      <div className="benefits-cards-grid-container">
        <div className="benefits-cards-grid">
          {/* Top Row: Benefits */}
          <BenefitCard 
            icon={increasedRevenueIcon} 
            title="Reduce Fraud" 
            description="Prevent identity theft and unauthorized access with advanced verification tools. " 
          />
          <BenefitCard 
            icon={scalabilityIcon} 
            title="Customer Engagement" 
            description="Automate KYC verification to enhance efficiency and build customer trust " 
          />
          <BenefitCard 
            icon={customerRetentionIcon} 
            title="Regulatory Compliance" 
            description="Easily meet government and financial regulations with secure, compliant APIs." 
          />

          {/* Bottom Row: Use Cases */}
          <BenefitCard 
            icon={fintechIcon} 
            title="Banking & Fintech" 
            description="Verify users seamlessly for account openings, onboarding, and transactions." 
          />
       
          <BenefitCard 
            icon={retailIcon} 
            title="E-commerce & Digital Wallets" 
            description="Onboard new customers securely with fast digital verification APIs." 
          />
             <BenefitCard 
            icon={ecommerceIcon} 
            title="Loan & Insurance Providers" 
            description="Authenticate applicants instantly before approval to ensure trust and accuracy." 
          />
        </div>
      </div>
    </section>
  </div>

      {/* Core Values & How It Works */}
 
 <section className="relative py-16 px-4 md:px-8 lg:px-16 overflow-hidden" style={{
      backgroundImage: `url(${integrationProcessImage})`,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
    }}>
      <div className="max-w-7xl mx-auto">
        {/* --- Top Section Header and Title --- */}
 <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
    >
    Integration & Security
  </span>
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12 leading-tight">
          Seamless Integration With <br />
          Advanced Security
        </h1>

        {/* -------------------------------------- */}
        {/* --- 1. Integration Process Section --- */}
        {/* -------------------------------------- */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
          
          <div className="relative w-full lg:w-1/2 min-h-[300px]"> 
            <div className="w-full h-full absolute top-0 left-0">
              <img 
                src={securityMeasuresImage} 
                alt="Integration Process" 
                className="w-[90%] h-full object-cover rounded-xl shadow-2xl" 
       
              />
            </div>

   
<div 
  className="absolute top-1/4 right-0 bg-[#F9F9F9] rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]
             flex flex-col items-start p-6 flex-1">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
              <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                Seamlessly integrate our APIs with your platform using our well-documented,...
              </p>
              <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                SEE MORE <span className="ml-2">→</span>
              </a>
            </div>
          </div>

          {/* Right Side: Checklist */}
          <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
            <ul className="space-y-6">
              {[
                "Sign Up & Get API Keys.",
                "Upload & Verify Documents via API Calls.",
                "Receive Verification Status in Real-Time.",
             
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-[#00AFEF]  font-bold text-lg mr-3 mt-1">✓</span>
                  <p className="text-lg text-gray-700">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ------------------------------------- */}
        {/* --- 2. Security Measures Section --- */}
        {/* ------------------------------------- */}

    <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
                <span 
                  className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
                >
                  Integration & Security
                </span>
                {/* Removed <br></br> */}
                
                {/* Added mt-4 or mb-4 to the list for separation */}
                <ul className="space-y-6 mt-4"> 
                  {[
                    "Data Encryption: Protects user data from breaches.",
                    "Multi-Layer Authentication: Ensures only authorized access. ",
                    "Audit Logs & Monitoring: Tracks identity verification history. ",
                  ].map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#00AFEF] font-bold text-lg mr-3 mt-1">✓</span>
                      <p className="text-lg text-gray-700">{item}</p>
                    </li>
                  ))}
                </ul>
            </div>
          <div className="relative w-full lg:w-1/2 min-h-[300px]"> 
            <div className="w-full h-full absolute top-0 left-0">
              <img 
                src={securitysecurityMeasuresImage} 
                alt="Integration Process" 
                className="w-[90%] h-full object-cover rounded-xl shadow-2xl" 
        
              />
            </div>

            <div className="absolute top-1/4 right-0 bg-[#F9F9F9] p-6 rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
              <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                Seamlessly integrate our APIs with your platform using our well-documented,...
              </p>
              <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                SEE MORE <span className="ml-2">→</span>
              </a>
            </div>
          </div>

         
        </div>


 
      </div>
    </section>




    </>
  );
};

export default KycApis;
